import { render, staticRenderFns } from "./form5_1b.vue?vue&type=template&id=ad60a14a&scoped=true"
import script from "./form5_1b.vue?vue&type=script&lang=js"
export * from "./form5_1b.vue?vue&type=script&lang=js"
import style0 from "./form5_1b.vue?vue&type=style&index=0&id=ad60a14a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad60a14a",
  null
  
)

export default component.exports